import { render, staticRenderFns } from "./BrokerProfile.vue?vue&type=template&id=1f12b30e&"
import script from "./BrokerProfile.vue?vue&type=script&lang=js&"
export * from "./BrokerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports